<template>
  <div class="super-admin-view">
    <img src="@/assets/image/homeIndex/page_bg.png" class="page-bg" alt="" srcset="" />
    <img src="@/assets/image/homeIndex/page_header.png" class="page_header" alt="" srcset="" />
    <img src="@/assets/image/homeIndex/page_left_bg.png" class="page_left_bg" alt="" srcset="" />
    <img src="@/assets/image/homeIndex/page_right_bg.png" class="page_right_bg" alt="" srcset="" />
    <img
      src="@/assets/image/homeIndex/page_bottom_bg.png"
      class="page_bottom_bg"
      alt=""
      srcset=""
    />
    <img
      src="@/assets/image/homeIndex/page_left_bottom.png"
      class="page_left_bottom"
      alt=""
      srcset=""
    />
    <img
      src="@/assets/image/homeIndex/page_right_bottom.png"
      class="page_right_bottom"
      alt=""
      srcset=""
    />
    <div class="home-title">{{ title }}</div>
    <div class="current-time">{{ currentTime }}</div>

    <div class="home-content">
      <div class="home-left-box dark-scrol-view">
        <noticeComponent ref="noticeRef" />
        <inspectStatisticsComponent ref="inspectRef" />
        <taskFlowComponent ref="taskFlowRef" />
      </div>
      <div class="home-center-box">
        <centerStatisticsComponent ref="centerRef" />
        <div class="map-view">
          <img src="@/assets/image/homeIndex/map_bg.png" class="map-bg" alt="" srcset="" />
          <img
            src="@/assets/image/homeIndex/map_left_bg.png"
            class="map-left-bg"
            alt=""
            srcset=""
          />
          <img
            src="@/assets/image/homeIndex/map_right_bg.png"
            class="map-right-bg"
            alt=""
            srcset=""
          />
          <div class="map-view-body">
            <ml-echarts
              id="ce"
              @click-map="clickMap"
              v-if="companyInfosData.length > 0 && mapIndex === 0"
              :option="mOption(companyInfosData, companyInfosDataIndex, mapIndex)"
            />
            <ml-echarts
              id="ce1"
              @click-map="clickMap"
              v-if="companyInfosData.length > 0 && mapIndex === 1"
              :option="mOption(companyInfosData, companyInfosDataIndex, mapIndex)"
            />
          </div>
        </div>
        <div class="map-view-btn-box">
          <div class="map-view-btn">
            <div class="toggle-item" :class="{ active: mapIndex === 0 }" @click="mapIndex = 0">
              全国
            </div>
            <div class="toggle-item" :class="{ active: mapIndex === 1 }" @click="mapIndex = 1">
              广东
            </div>
          </div>
        </div>
        <pendingFaultComponent ref="pendingFaultRef" />
      </div>
      <div class="home-right-box dark-scrol-view">
        <faultStatisticsComponent ref="faultStatisticsRef" />
        <faultWorkOrderComponent ref="faultWorkOrderRef" />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getTabberData } from '@utils'
import mOption from '@utils/viewData/mV2'
import noticeComponent from './components/noticeComponent.vue'
import inspectStatisticsComponent from './components/inspectStatisticsComponent.vue'
import taskFlowComponent from './components/taskFlowComponent.vue'
import faultStatisticsComponent from './components/faultStatisticsComponent.vue'
import faultWorkOrderComponent from './components/faultWorkOrderComponent.vue'
import centerStatisticsComponent from './components/centerStatisticsComponent.vue'
import pendingFaultComponent from './components/pendingFaultComponent.vue'
export default {
  name: 'SuperAdminView',
  components: {
    noticeComponent,
    inspectStatisticsComponent,
    taskFlowComponent,
    faultStatisticsComponent,
    faultWorkOrderComponent,
    centerStatisticsComponent,
    pendingFaultComponent
  },
  setup() {
    const title = ref('智慧运维指挥中心')
    const { commit, dispatch } = useStore()
    const router = useRouter()

    // 当前时间显示（年月日时分秒，持续更新）
    const currentTime = ref('')
    const timeTimerId = ref(null)
    const formatTime = date => {
      const pad = n => String(n).padStart(2, '0')
      const y = date.getFullYear()
      const m = pad(date.getMonth() + 1)
      const d = pad(date.getDate())
      const h = pad(date.getHours())
      const min = pad(date.getMinutes())
      const s = pad(date.getSeconds())
      return `${y}年${m}月${d}日 ${h}:${min}:${s}`
    }
    const updateTime = () => {
      currentTime.value = formatTime(new Date())
    }

    // 地图数据
    const companyInfosData = ref([])
    const companyInfosDataIndex = ref(0)
    const nsetInterval = ref()
    const getCompanyInfos = async () => {
      const { data } = await getTabberData(dispatch, 'fetchCompanyStatisticsList')
      let index = -1
      nsetInterval.value = setInterval(() => {
        companyInfosData.value = data
        index++
        companyInfosDataIndex.value = index
        if (index >= data.length - 1) {
          index = -1
        }
      }, 10000)
    }

    const clickMap = params => {
      if (params.componentSubType === 'effectScatter') {
        commit('setmapLabelData', params.data)
        router.push({ path: '/monitoringLayer' })
      }
    }

    // 地图切换
    const mapIndex = ref(1)

    // 子组件引用
    const noticeRef = ref(null)
    const inspectRef = ref(null)
    const taskFlowRef = ref(null)
    const centerRef = ref(null)
    const pendingFaultRef = ref(null)
    const faultStatisticsRef = ref(null)
    const faultWorkOrderRef = ref(null)

    // 统一刷新所有子组件数据（3分钟）
    const refreshAll = () => {
      centerRef.value?.refreshData()
      inspectRef.value?.refreshData()
      noticeRef.value?.refreshData()
      taskFlowRef.value?.refreshData()
      faultStatisticsRef.value?.refreshData()
      faultWorkOrderRef.value?.refreshData()
      pendingFaultRef.value?.refreshData()
      // 地图数据刷新前先清除轮播定时器
      clearInterval(nsetInterval.value)
      getCompanyInfos()
    }

    const initSetInterId = ref()
    const getSetInterval = () => {
      const time = 3 * 60 * 1000
      initSetInterId.value = setInterval(() => {
        refreshAll()
      }, time)
    }

    onMounted(() => {
      getCompanyInfos()
      getSetInterval()
      // 启动当前时间定时更新（每秒）
      updateTime()
      timeTimerId.value = setInterval(updateTime, 1000)
    })

    onUnmounted(() => {
      clearInterval(nsetInterval.value)
      clearInterval(initSetInterId.value)
      clearInterval(timeTimerId.value)
    })

    return {
      title,
      currentTime,
      mOption,
      companyInfosData,
      companyInfosDataIndex,
      mapIndex,
      clickMap,
      noticeRef,
      inspectRef,
      taskFlowRef,
      centerRef,
      pendingFaultRef,
      faultStatisticsRef,
      faultWorkOrderRef
    }
  }
}
</script>
<style lang="scss" scoped>
.super-admin-view {
  box-sizing: border-box;
  height: 100%;
  position: relative;
  padding-top: 90px;
  box-sizing: border-box;
  overflow: hidden;
}
.page-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}
.page_header {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}
.page_left_bg {
  width: 16px;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  object-fit: cover;
}
.page_right_bg {
  width: 16px;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  object-fit: cover;
}
.page_bottom_bg {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  object-fit: cover;
}
.page_left_bottom {
  width: 410px;
  height: 408px;
  position: absolute;
  bottom: 0;
  left: 0;
  object-fit: cover;
}
.page_right_bottom {
  width: 410px;
  height: 408px;
  position: absolute;
  bottom: 0;
  right: 0;
  object-fit: cover;
}
.home-title {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 48px;
  color: #fff;
  font-family: 'PangMenZhengDao';
  letter-spacing: 14px;
  text-shadow: 0px 0px 14px #0090ff, 0px 0px 8px #0090ff, 0px 3px 2px rgba(0, 0, 0, 0.5);
}
.current-time {
  position: absolute;
  top: 28px;
  right: 32px;
  z-index: 10;
  font-size: 16px;
  color: #D5EAFF;
  font-family: 'SourceHanSansCN-Regular';
  letter-spacing: 1px;
  text-shadow: 0px 0px 8px rgba(0, 144, 255, 0.6);
}
.home-content {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: space-between;
}
.home-left-box {
  width: 400px;
  margin-left: 32px;
  height: 100%;
  padding-bottom: 30px;
  box-sizing: border-box;
  overflow-y: auto;
}
.home-right-box {
  width: 400px;
  margin-right: 32px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.home-center-box {
  width: calc(100% - 864px);
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
.map-view {
  height: calc(100% - 356px);
  width: calc(100% - 80px);
  margin: 0 40px;
  margin-top: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  &-body {
    flex: 1;
    position: relative;
  }
  .map-bg {
    width: auto;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .map-left-bg {
    width: 151px;
    height: 541px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  .map-right-bg {
    width: 151px;
    height: 541px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}
.map-view-btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.map-view-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 178px;
  height: 34px;
  background: linear-gradient(180deg, rgba(0, 47, 93, 0.3), rgba(0, 128, 255, 0.5) 100%);
  border: 1px solid rgba(0, 128, 255, 0.2);
  border-radius: 16px;
  .toggle-item {
    width: 86px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    border-radius: 16px;
    font-size: 14px;
    font-family: 'SourceHanSansCN-Regular', sans-serif;
    letter-spacing: 0.13px;
    color: rgba(255, 255, 255, 0.7);
    &.active {
      color: #ffffff;
      font-family: 'SourceHanSansCN-Medium', sans-serif;
      font-weight: 500;
      background: linear-gradient(180deg, #002f5d, #0080ff 100%),
        radial-gradient(#33cdff, rgba(0, 57, 115, 0));
      border: 1px solid rgba(0, 128, 255, 0.6);
    }
  }
}
</style>
